
import { batch } from 'react-redux';

import { addEltHistory } from '../state/reactquery';
import { store  ,modifyQualiflead,modifyDisplaymodal,modifyEtattel,
         initialiseLeadactu,  initialiseLeadappelant , modifyEcran ,
		     allFormules , defineDevisFormules ,modifyMessagetel} from '../state/redux';

import { findclientfromtel } from './phone';
import { getallformules } from './calculstarifs';
import { modifyonelead } from "./actions_lead";



    export const handle_incoming_call = async (callInfos) => {
       console.log('XXXXXhandle_incoming_call',callInfos) ;
        store.dispatch(modifyEtattel('appel'));
        store.dispatch(modifyMessagetel(callInfos.from));
        const nb = store.getState().lead.leadactu.nbappels || 0 ;
        modifyonelead({'nbappels': nb+1}) ;
        const id_lead = await findclientfromtel(callInfos.from);
        id_lead && addEltHistory(id_lead ,'appelsortant',  `<div class='horoline1' >Appel entrant</div>` ) ;
        // document.getElementById('aircallphone').classList.toggle('displaynone') ; 
         document.getElementById('workspace').classList.toggle('displaynone') ; 
      };
      
      export const handle_call_end_ringtone= (callInfos) => {
        console.log('XXXXXhandle_call_end_ringtone', callInfos ,callInfos.answer_status) ;
        // call_end_ringtone {answer_status: 'answered', call_id: 2276769500}
        if(callInfos.answer_status=='answered'){
          store.dispatch(modifyQualiflead((store.getState().lead.leadappelant.id && store.getState().lead.leadappelant!=='gagne')?false:true));  
          store.dispatch(allFormules([]));  
          store.dispatch(defineDevisFormules([])); 
          store.dispatch(modifyEtattel('appel')) ;
        
          batch( () => {store.getState().lead.leadappelant.id && store.dispatch(initialiseLeadactu( store.getState().lead.leadappelant));  
                   store.getState().lead.leadappelant.id && store.dispatch(modifyEcran('ficheclient'));  });
          setTimeout(()=>{ store.getState().lead.leadappelant.id &&  store.dispatch(getallformules());}, 1000) ;
          setTimeout(()=>{store.dispatch(initialiseLeadappelant({})) ; }, 2000) ;
        }
        
      };
      
      export const handle_call_ended= (callInfos) => {
           console.log('XXXXXhandle_call_ended',callInfos) ;
        store.dispatch(modifyEtattel('normal')) ;
        store.dispatch(initialiseLeadappelant({})) ;
        (store.getState().lead.qualiflead===false && !store.getState().display.displaymodal?.includes('mod_qualiflead') )&& store.dispatch(modifyDisplaymodal('mod_qualiflead'));

      };
      
      export const handle_comment_saved= (callInfos) => {
        console.log('comment_saved' , callInfos)
      };
      
      export const handle_outgoing_call= (callInfos) => {
        console.log('XXXXXoutgoing_call', callInfos) ;
        store.dispatch(modifyEtattel('appel'));
        const nb = store.getState().lead.leadactu.nbappels || 0 ;
         console.log('XXXXXoutgoing_call', nb ) ;
        modifyonelead({'nbappels': nb+1}) ;

      };
      
      export const handle_outgoing_answered= (callInfos) => {
        console.log('outgoing_answered', callInfos) ;
      };
